module.exports = __webpack_public_path__ + "img/202506_04.bab54700.jpg";